import React from 'react';
import '../../styles/app/AcceptableUsePolicy.css';
import WhatsAppBanner from './WhatsAppBanner';
import Nav from './Nav';
import { useTranslation } from 'react-i18next';

const AcceptableUsePolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <WhatsAppBanner />
      <Nav />
      <section className="aup-section">
        <div className="aup-container">
          <h1>{t('acceptableUsePolicy.title')}</h1>

          <h2>{t('acceptableUsePolicy.purpose.title')}</h2>
          <p>{t('acceptableUsePolicy.purpose.paragraph')}</p>

          <h2>{t('acceptableUsePolicy.prohibitedUses.title')}</h2>
          <p>{t('acceptableUsePolicy.prohibitedUses.paragraph')}</p>
          <ul>
            <li>{t('acceptableUsePolicy.prohibitedUses.list.0')}</li>
            <li>{t('acceptableUsePolicy.prohibitedUses.list.1')}</li>
            <li>{t('acceptableUsePolicy.prohibitedUses.list.2')}</li>
            <li>{t('acceptableUsePolicy.prohibitedUses.list.3')}</li>
            <li>{t('acceptableUsePolicy.prohibitedUses.list.4')}</li>
            <li>{t('acceptableUsePolicy.prohibitedUses.list.5')}</li>
          </ul>

          <h2>{t('acceptableUsePolicy.userContent.title')}</h2>
          <p>{t('acceptableUsePolicy.userContent.paragraph')}</p>

          <h2>{t('acceptableUsePolicy.enforcement.title')}</h2>
          <p>{t('acceptableUsePolicy.enforcement.paragraph')}</p>

          <h2>{t('acceptableUsePolicy.policyChanges.title')}</h2>
          <p>{t('acceptableUsePolicy.policyChanges.paragraph')}</p>
        </div>
      </section>
    </>
  );
};

export default AcceptableUsePolicy;
